import { render, staticRenderFns } from "./interactive-gallery.vue?vue&type=template&id=69453e12"
import script from "./interactive-gallery.vue?vue&type=script&lang=js"
export * from "./interactive-gallery.vue?vue&type=script&lang=js"
import style0 from "./interactive-gallery.vue?vue&type=style&index=0&id=69453e12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InteractiveGalleryItem: require('/app/components/profile/interactive-gallery-item.vue').default})
